import { createFileRoute } from "@tanstack/react-router";
import AdminAuditLog from "@/pages/AdminAuditLog";

export const Route = createFileRoute("/admin/audit-log/")({
  component: AdminAuditLog,
});
